import { Button } from "@/shared/components";
import { RowData, Table } from "@tanstack/react-table";
import type { DataTableFeatures } from "./data-table-features";

type DataTableClearAllFiltersButtonProps<TData extends RowData> = {
    table: Table<DataTableFeatures, TData>;
};

/**
 * Button component that clears all active filters in a data table.
 * Only renders when at least one filter is active.
 * Clears both column filters (text, multi-select, boolean) and global filter.
 */
export function DataTableClearAllFiltersButton<TData extends RowData>({ table }: DataTableClearAllFiltersButtonProps<TData>) {
    const columnFilters = table.store.state.columnFilters;
    const globalFilter = table.store.state.globalFilter as string;
    const hasActiveFilters = columnFilters.length > 0 || globalFilter.trim() !== "";

    if (!hasActiveFilters) {
        return null;
    }

    const handleClearAll = () => {
        table.setGlobalFilter("");
        table.resetColumnFilters();
    };

    return (
        <Button
            variant="secondary"
            destructive
            size="s"
            onClick={handleClearAll}
            className="border-default border"
            data-testid="clear-all-filters"
            title="Alle filters verwijderen"
            icon="close"
            iconSize="xs"
        >
            Wis alle filters
        </Button>
    );
}
